/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// React library
import { Component, createRef } from 'react';

// React redux
import { connect } from 'react-redux';

// Project library
import { webContentList } from 'shared/settings/apiconfig';
import { CTBIDS_CONTENT } from 'shared/settings/config';
import Datatable from 'shared/datatable';

// Service
import Axios from 'axios';
import { getAdminHeaders, getAdminUrl } from 'shared/http';

// react-bootstrap
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';

// style imports
import './CtbidsContentList.scss';

/**
 * this page is used to list ctbids content
 * 
 * @param props
 * 
 * @returns html code to render the ctbids content list
 * 
**/

class CtbidsContentList extends Component {
    constructor(props) {
        super(props);
        this.dataTable = createRef();
        this.initialSearchState = {
            type: { field: "type", value: "", op: "=", join: "AND" },
        }
        this.state = {
            search: this.initialSearchState,
            searchData: false,
            contentType: CTBIDS_CONTENT,
            tableData: [],
            issearch: false,
            pageLoading: false,
            isMock: true,
            mockData: [],
            viewModal: false,
            viewModalData: {}
        };
        this.config = {
            name: 'Ctbids Content',
            url: webContentList,
            createurl: '/ctbids-content/add',
            params: {},
            columns: [
                {
                    name: '', property: 'id', columnType: 'actions', actions: ['view', 'edit'], customHeader: <><div><Button className="save-button" style={{ marginLeft: "10%" }} onClick={() => this.navigateToAdd()}>+ Create</Button></div></>, width: '100px',
                    actionEvents: {
                        view: this.viewContent, edit: (row, state) => this.editData(row, state)
                    }
                },
                { name: 'Type', property: 'type', sort: true, width: '250px', columnType: 'custom', customColumn: this.customType },
                { name: 'Content Text', property: 'description', sort: false, width: '130px', columnType: 'custom', customColumn: this.descriptionColoumn },
                { name: 'Status', property: 'status', sort: true, width: '130px', columnType: 'custom', customColumn: this.statusColoumn }
            ],
            sort: [{
                "field": "id",
                "direction": "desc"
            }],
            pagination: true,
            adminUrl: {}
        };
        if (props.location.state && props.location.state.datatable && props.location.state.datatable.search) {
            let tempSearch = { ...this.initialSearchState };
            const search = [...props.location.state.datatable.search];

            search.forEach(element => {
                let temp = { ...element };
                if (typeof temp['value'] === 'string') {
                    temp['value'] = temp['value'].replace(/(^\*)|(\*$)/g, '');
                }
                tempSearch[temp['field']] = temp;
            });

            this.state['search'] = tempSearch;
            this.state['issearch'] = Boolean(search.length);
            this.state['searchData'] = true;
            this.enableSearch();
        }
    }

    componentDidMount() {
        // this.getData();
    }

    getStateData = () => {
        const contentState = this.props?.location?.state;
        const contentSearch = contentState?.datatable?.search;
        if (!(contentSearch && !contentState?.prevPath)) {
            return;
        }
        const updatedState = {};
        updatedState['search'] = contentSearch?.length > 0 ? [...contentSearch].reduce(
            (acc, element) => {
                const elementDestruct = { ...element };
                acc[elementDestruct['field']] = elementDestruct;
                return acc;
            }, { ...this.initialSearchState }) :
            {
                type: {
                    ...this.initialSearchState.locationid,
                    value: ""
                }
            };
        updatedState['issearch'] = contentState['issearch'];
        updatedState['searchData'] = true;
        return updatedState;
    }

    // Getting required data
    getData() {
        const contentState = this.getStateData();
        if (this.state.contentType.length > 0) {
            this.setState({
                ...this.state,
                pageLoading: false,
                ...contentState
            }, () => {
                if (contentState.issearch) {
                    this.enableSearch();
                }
            });
        }
    }

    // Description coloumn
    descriptionColoumn = (data) => {
        return (
            <div dangerouslySetInnerHTML={{ __html: data.description }}></div>
        );
    }
    customType = (data)=>{
        if(data.type === 'CTBIDS_BANNERTEXT_NONPREMIER'){
            return 'ALL_REGISTERED_CTBIDS_CUSTOMERS'
        }
        else{
            return data.type
        }
    }

    // Status coloumn
    statusColoumn = (data) => {
        return (
            <div>{data.status === 1 ? "Active" : "Inactive"}</div>
        );
    }

    // edit data 
    editData = (row, state) => {
        this.props.history.push({ pathname: `/ctbids-content/edit/${row.id}`, state: state });
    }

    // handle enter key search
    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.enableSearch()
        }
    }
    /* called when search input changes */
    searchInputChange = (event) => {
        let eventValue = event.target.value;
        this.setState({
            ...this.state,
            issearch: true,
            search: {
                ...this.state.search,
                [event.target.name]: {
                    ...this.state.search[event.target.name],
                    value: eventValue
                }
            },
            searchData: false
        }, () => {
            if (event.target.value === '')
                this.resetState();
        });
    }

    /* called when clear in search clicked */
    resetState = () => {
        this.setState({
            ...this.state,
            search: this.initialSearchState,
            searchData: false,
            issearch: false,
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    updateTableData = (event) => {
        this.setState({
            ...this.state,
            tableData: event
        });
    }

    /* called when search button clicked */
    enableSearch = () => {
        var search = {
            type: { ...this.state.search.type },
        }
        this.setState({
            filterSearch: this.state.search.type.value === "all" ? [] : search,
            searchData: true
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    /** Called when click create button */
    navigateToAdd = () => {
        this.props.history.push('/ctbids-content/add');
    }

    // open view modal
    viewContent = (data) => {
        this.setState({
            viewModal: true,
            viewModalData: data
        });
    }

    // close view modal
    closeViewModal = () => {
        this.setState({
            viewModal: false
        });
    }

    render() {
        return (
            <div className="ctbids-content-list">
                {
                    this.state.pageLoading ?
                        <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100">
                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="default" height="100px" width="100px" />
                        </div> : <div>
                            <div className="sale-search">
                                <div className="sales-list-search">
                                    <Form className="sales-list-font">
                                        <div className="sales-search-container">
                                            <Row>
                                                <Col>
                                                    <label>Content Type</label>
                                                    <Form.Control as="select" name="type" value={this.state.search.type.value} onKeyDown={this._handleKeyDown} onChange={(event) => this.searchInputChange(event)}>
                                                        <option value="" disabled>Please select type</option>
                                                        {this.state.contentType.length > 1 ? <option value="all">All</option> : null}
                                                        {this.state.contentType.map((type, index) =>
                                                            <option key={index} value={type.value}>{type.name}</option>
                                                        )}
                                                    </Form.Control>
                                                </Col>
                                                <Col>
                                                    <div className="mt-3">
                                                        <Button className="clear-button" onClick={() => this.resetState()}>Clear All</Button>
                                                        <Button variant="search-button" disabled={!this.state.search.type.value} onClick={() => this.enableSearch()}>Search</Button>
                                                    </div>
                                                </Col>
                                                <Col></Col>
                                                <Col></Col>
                                            </Row>
                                        </div>
                                    </Form>

                                </div>
                            </div>
                            <div className="sale-list">
                                <Datatable config={{ ...this.config }} search={this.state.searchData ? { search: { ...this.state.filterSearch }, searchData: this.state.searchData } : null} ref={this.dataTable} onDataUpdate={this.updateTableData}{...this.props}></Datatable>
                            </div>
                        </div>
                }
                <Modal id="contentTemplate" show={this.state.viewModal} size="lg" animation={false} onHide={this.closeViewModal} keyboard={false}>
                    <Modal.Header style={{ border: "none" }}>
                        <div>
                            {
                                this.state.viewModalData.type ?
                                    <h6>{this.state.viewModalData.type}</h6>
                                    : null
                            }
                        </div>
                        <Button type="button" onClick={this.closeViewModal} className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></Button>
                    </Modal.Header>
                    <Modal.Body className="templateClass">
                        {
                            this.state.viewModalData.description ?
                                <div className="ql-editor" style={{ padding: "1rem" }} dangerouslySetInnerHTML={{ __html: this.state.viewModalData.description }} />
                                : null
                        }
                        <div className="text-center p-3">
                            <Button variant="secondary" onClick={this.closeViewModal}>Close</Button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default connect(state => state)(CtbidsContentList);